import React from 'react';
import PropTypes from 'prop-types';
import Span from '@deliveroo/consumer-component-library/components/Span';

import styles from './styles.scss';

/**
 * A link to a named location, e.g. a Brand location
 */
export default function LocationLink({ url, name }) {
  return (
    <a href={url} className={styles.link}>
      <Span>{name}</Span>
    </a>
  );
}

LocationLink.propTypes = {
  /**
   * URL of the location link, i.e. the menu page to link to
   */
  url: PropTypes.string.isRequired,

  /**
   * Name of the location, i.e. the text of the link
   */
  name: PropTypes.string.isRequired,
};
